module.exports = __webpack_public_path__ + "img/redirect.d5bfa07d.svg";